import { createContext, useContext } from 'react'

import { CelebrationContextValue } from './celebration-context-types'

const CelebrationContext = createContext<CelebrationContextValue | null>(null)

/**
 * Reads the celebration context. Throws if used outside the provider.
 *
 * @returns {CelebrationContextValue}
 */
const useCelebration = (): CelebrationContextValue => {
  const context = useContext(CelebrationContext)

  if (context === null) {
    throw new Error('useCelebration must be used within a CelebrationProvider')
  }

  return context
}

export { CelebrationContext, useCelebration }
